"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ActionItemSearchServiceQueryParams", {
    enumerable: true,
    get: function() {
        return ActionItemSearchServiceQueryParams;
    }
});
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _base = require("../../base");
const ActionItemSearchServiceQueryParams = _base.BaseSearchServiceQueryParams.extend({
    service: _zod.z.literal("action_item"),
    name_re: _zod.z.string().optional(),
    created_user_id_eq: _utilsisomorphic.transformObjectId.optional(),
    participants_user_id_eq: _utilsisomorphic.transformObjectId.optional(),
    is_unassigned_eq: _zod.z.literal("true").optional(),
    most_recent_meeting_status_eq: _zod.z.string().optional(),
    most_recent_meeting_status_in: _zod.z.array(_zod.z.string()).optional(),
    due_date_gte: _utilsisomorphic.transformDate.optional(),
    due_date_lte: _utilsisomorphic.transformDate.optional(),
    workspace_id_eq: _utilsisomorphic.transformObjectId.optional()
});
